import Vue from 'vue'
import App from './App'
import router from './router'
import VueScroller from 'vue-scroller'
Vue.use(VueScroller)
Vue.config.productionTip = false
import remConfig from './assets/js/rem'
remConfig();
/*vue-lazyload*/
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
/*element-ui*/
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);
import './assets/css/reset.css'
import './assets/css/border.css'
import './assets/font/font.css'
//数字金额三位加逗号
Vue.filter('capitalize', function (value) {
  	if(value<0){
  		return "-"
  	}
  	value = String(value);
  	if (!value) return ''
  	if(value.indexOf('.') == -1){
  		value = value.split('').reverse();
	  	for(let i=2;i<value.length-1;i+=3){
	  		value[i]+=','
	  	}
	  	return value.join("").split("").reverse().join("");
  	}else{
  		let end = value.split(".")[1]
  		value = value.split(".")[0]
  		value = value.split('').reverse();
	  	for(let i=2;i<value.length-1;i+=3){
	  		value[i]+=','
	  	}
	  	value = value.join("").split("").reverse().join("") 
	  	return value+'.'+ end;
  	}
})
//房屋尺寸带单位
Vue.filter('lot_capita', function (value) {
  	if(value<0 || value==''){
  		return "-"
  	}
  	value = String(value);
  	value = value.replace(/(^\s*)|(\s*$)/g, "")
  	if (!value) return ''
  	if(value.indexOf('.') == -1){
  		value = value.split('').reverse();
	  	for(let i=2;i<value.length-1;i+=3){
	  		value[i]+=','
	  	}
	  	return value.join("").split("").reverse().join("")+'ft²';
  	}else{
  		let end = value.split(".")[1]
  		value = value.split(".")[0]
  		value = value.split('').reverse();
	  	for(let i=2;i<value.length-1;i+=3){
	  		value[i]+=','
	  	}
	  	value = value.join("").split("").reverse().join("") 
	  	return value+'.'+ end+'ft²';
  	}
})
//数字金额转化为大写
Vue.filter('capital', function (money) {
	//最大处理的数字
  	let maxNum = 999999999999999.9999;
		if(money<0 || money=="" || money>maxNum){
  		return ""
  	}
  	//汉字的数字
  	let cnNums = new Array('零', '一', '二', '三', '四', '五', '六', '七', '八', '九');
  	//基本单位
  	let cnIntRadice = new Array('', '十', '百', '千');
  	//对应整数部分扩展单位
  	let cnIntUnits = new Array('', '万', '亿', '兆');
  	//对应小数部分单位
  	let cnDecUnits = new Array('角', '分', '毫', '厘');
  	//整型完以后的单位
  	let cnIntLast = '元';
  	//金额整数部分
  	let integerNum;
  	//金额小数部分
  	let decimalNum;
  	//输出的中文金额字符串
  	let chineseStr = '';
  	//分离金额后用的数组，预定义
  	let parts;
  	if (money == '') { return ''; }
  	money = parseFloat(money);
  	if (money >= maxNum) {
    	//超出最大处理数字
    	return '';
  	}
  	if (money == 0) {
	    chineseStr = cnNums[0] + cnIntLast;
	    return chineseStr;
	}
	//转换为字符串
	money = money.toString();
	if (money.indexOf('.') == -1) {
	    integerNum = money;
	    decimalNum = '';
	} else {
	    parts = money.split('.');
	    integerNum = parts[0];
	    decimalNum = parts[1].substr(0, 4);
	}
	//获取整型部分转换
	if (parseInt(integerNum, 10) > 0) {
	    let zeroCount = 0;
	    let IntLen = integerNum.length;
	    for (var i = 0; i < IntLen; i++) {
	      	let n = integerNum.substr(i, 1);
	      	let p = IntLen - i - 1;
	      	let q = p / 4;
	      	let m = p % 4;
	      	if (n == '0') {
	        	zeroCount++;
	      	} else {
	        	if (zeroCount > 0) {
	          		chineseStr += cnNums[0];
	       	 	}
	        	//归零
	        	zeroCount = 0;
	        	chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
	      	}
	      	if (m == 0 && zeroCount < 4) {
	        	chineseStr += cnIntUnits[q];
	      	}
	    }
	    chineseStr += cnIntLast;
	}
	//小数部分
	if (decimalNum != '') {
	    let decLen = decimalNum.length;
	    for (let i = 0; i < decLen; i++) {
	      	let n = decimalNum.substr(i, 1);
	      	if (n != '0') {
	        	chineseStr += cnNums[Number(n)] + cnDecUnits[i];
	      	}
	    }
	}
	if (chineseStr == '') {
	    chineseStr += cnNums[0] + cnIntLast;
	}  
  	return chineseStr;
})
//保留小数点后两位
Vue.filter(
  'decimal_2',function(val){
    if(val){
      return parseFloat(val).toFixed(2);
    }else{
      if(val==0){
        return 0;
      }else{
        return '- '
      }
    }
  }
)
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})





// WEBPACK FOOTER //
// ./src/main.js